/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BuildInfoResponseDto,
  DomainErrorDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const buildInfoControllerGetBuildInfo = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<BuildInfoResponseDto>(
      {url: `/api/v1/build-info`, method: 'GET', signal
    },
      options);
    }




export const getBuildInfoControllerGetBuildInfoQueryKey = () => {
    return [
    `/api/v1/build-info`
    ] as const;
    }


export const getBuildInfoControllerGetBuildInfoQueryOptions = <TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuildInfoControllerGetBuildInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>> = ({ signal }) => buildInfoControllerGetBuildInfo(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BuildInfoControllerGetBuildInfoQueryResult = NonNullable<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>>
export type BuildInfoControllerGetBuildInfoQueryError = ErrorType<DomainErrorDto>


export function useBuildInfoControllerGetBuildInfo<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuildInfoControllerGetBuildInfo<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuildInfoControllerGetBuildInfo<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBuildInfoControllerGetBuildInfo<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBuildInfoControllerGetBuildInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getBuildInfoControllerGetBuildInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuildInfoControllerGetBuildInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>> = ({ signal }) => buildInfoControllerGetBuildInfo(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BuildInfoControllerGetBuildInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>>
export type BuildInfoControllerGetBuildInfoSuspenseQueryError = ErrorType<DomainErrorDto>


export function useBuildInfoControllerGetBuildInfoSuspense<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuildInfoControllerGetBuildInfoSuspense<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuildInfoControllerGetBuildInfoSuspense<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBuildInfoControllerGetBuildInfoSuspense<TData = Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof buildInfoControllerGetBuildInfo>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBuildInfoControllerGetBuildInfoSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






